import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import CtitemInfo from '../CtitemInfo';


export default function CtitemListTableRow({obj, getActionComponent,handleRowClick}){
  const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard);
  const {rolename} = useSelector((state)=>state.headerslice.userprofileInfo);
  useEffect(()=>{
  },[])

  const getDemand = () =>{
    let demand = productObj.batchsize*productObj.packagingsize1name*productObj.packagingsize1name*obj.quantity
    if (obj.unitname==='MG'){
       return (demand / 1_000_000) +' KG'
    }

  }
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{
              //cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'secondary.lighter', color: 'primary.main'
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            
              <Grid item lg={4} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.quantity} {obj.unitname}</Typography></Grid>
              {rolename==='PHARMA_OMS_QA'?<></>
              :<>
                <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{productObj.batchsize}X{productObj.packagingsize1name}X{productObj.packagingsize1name}</Typography></Grid>
                <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{getDemand()}</Typography></Grid>
              </>
              }
              <Grid item lg={2} xs={2} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {getActionComponent(obj)}
                </Grid>
              </Grid>
          </Grid>
        </Grid>
        
        <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>
      </>
      
    )
}